import EmptyNewsieEditor from "./EmptyNewsieEditor";
import NewsiePreview from "./NewsiePreview";
import DateSelector from "../../../DateSelector";

import "./NewsieEditor.css";

const NewsieEditor = (props) => {
  const { selectedNewsie } = props;
  return (
      <div className="newsie-editor-continer">
        {/* <div className="top-row-buttons-container">
          <DateSelector />
        </div> */}

        {selectedNewsie ? (
          <NewsiePreview
            newsieInput={selectedNewsie.newsieInput}
            takeAwayPoints={selectedNewsie.takeAwayPoints}
          />
        ) : (
          <EmptyNewsieEditor />
        )}
      </div>
  );
};

export default NewsieEditor;
